import React from 'react';

interface InputProps extends React.InputHTMLAttributes<HTMLInputElement> {
  id?: string;
  type?: string;
  placeholder?: string;
  value?: string | number;
  onChange?: React.ChangeEventHandler<HTMLInputElement>;
  className?: string;
  error?: boolean;
  disabled?: boolean;
}

const Input: React.FC<InputProps> = ({
  id = '',
  type = 'text',
  placeholder = '',
  value,
  onChange,
  className = '',
  error = false,
  disabled = false,
  ...props
}) => {
  const baseStyles = 'border rounded-lg px-4 py-2 focus:outline-none focus:ring-2';
  const errorStyles = 'border-error focus:ring-error';
  const defaultStyles = 'border-gray-300 focus:ring-primary-500';

  return (
    <input
      id={id}
      type={type}
      placeholder={placeholder}
      value={value}
      onChange={onChange}
      disabled={disabled}
      className={`${baseStyles} ${error ? errorStyles : defaultStyles} ${className}`}
      {...props}
    />
  );
};

export default Input;
